<script>
import Serve from "../ui/prueba/serve.vue";
import axios from "axios";

import { getDocument } from "pdfjs-dist";

export default {
  components: {
    Serve,
  },
  props: {
    aforo: {
      type: Object,
      required: true,
    },
  },
  emits: ["refetch"],
  data() {
    return {
      aforoId: "",
      idDescargar: null,
      idArchivo: null,

      visorImagen: new Image(),

      numeroPaginas: 0,
      paginaActual: 1,

      visorWidth: 1000,
      visorHeight: 800,

      tipoDeArchivo: "",

      archivos: [],
      fotos: [],
      carpeta: [],

      nombre_archivo: "",

      showEditStatus: false,
    };
  },
  created() {
    window.addEventListener("resize", this.redimensionarVentana);
  },
  destroyed() {
    window.removeEventListener("resize", this.redimensionarVentana);
  },
  mounted() {
    this.aforoId = this.$route.params.aforoId;

    this.getArchivosAforo();
  },
  methods: {
    async abrirDocumento(id, nombre) {
      this.idArchivo = id;
      this.idDescargar = id;
      this.nombre_archivo = nombre.split("/")[1];
      await this.mostrarArchivo();
    },
    async mostrarArchivo() {
      try {
        const res = await axios.get(`/api/archivo/${this.idArchivo}/descargar`);

        if (res.headers["content-type"] == "application/pdf") {
          this.tipoDeArchivo = "pdf";
          await this.cargarPDF(this.paginaActual);
        } else if (
          res.headers["content-type"] == "image/png" ||
          res.headers["content-type"] == "image/jpeg"
        ) {
          this.tipoDeArchivo = "png";
          await this.cargarImagen();
        } else {
          this.tipoDeArchivo = "otro";
        }
      } catch (e) {
        console.error(e);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al obtener los archivos del aforo.",
        });
      }

      if (screen.width <= 320) {
        this.visorWidth = 280;
        this.visorHeight = 640;
      } else if (screen.width < 600) {
        this.visorWidth = 340;
        this.visorHeight = 640;
      } else if (screen.width <= 768) {
        this.visorWidth = 550;
        this.visorHeight = 690;
      } else if (screen.width < 1024) {
        this.visorWidth = 700;
        this.visorHeight = 690;
      } else {
        this.visorWidth = 1000;
        this.visorHeight = 890;
      }

      var init = false;
      this.visorImagen.onload = () => {
        var canvas = document.getElementById("visor-canvas");
        var ctx = canvas.getContext("2d");
        canvas.width = this.visorWidth;
        canvas.height = this.visorHeight;
        this.trackTransforms(ctx);

        var firstDraw = true;

        let redraw = () => {
          // Clear the entire canvas
          var p1 = ctx.transformedPoint(0, 0);
          var p2 = ctx.transformedPoint(canvas.width, canvas.height);
          ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);

          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.restore();
          if (this.visorImagen.src !== "") {
            if (firstDraw == true) {
              var ss = canvas.height / this.visorImagen.height;
              ctx.translate(
                (canvas.width - this.visorImagen.width * ss) / 2,
                0
              );
              ctx.scale(ss, ss);
              firstDraw = false;
            }
            ctx.drawImage(this.visorImagen, 0, 0);
          }
        };
        redraw();

        if (init == false) {
          var lastX = canvas.width / 2,
            lastY = canvas.height / 2;
          var dragStart, dragged;
          canvas.addEventListener(
            "mousedown",
            function (evt) {
              document.body.style.mozUserSelect =
                document.body.style.webkitUserSelect =
                document.body.style.userSelect =
                  "none";
              lastX = evt.offsetX || evt.pageX - canvas.offsetLeft;
              lastY = evt.offsetY || evt.pageY - canvas.offsetTop;
              dragStart = ctx.transformedPoint(lastX, lastY);
              dragged = false;
            },
            false
          );

          canvas.addEventListener(
            "mousemove",
            function (evt) {
              lastX = evt.offsetX || evt.pageX - canvas.offsetLeft;
              lastY = evt.offsetY || evt.pageY - canvas.offsetTop;
              dragged = true;
              if (dragStart) {
                var pt = ctx.transformedPoint(lastX, lastY);
                ctx.translate(pt.x - dragStart.x, pt.y - dragStart.y);
                redraw();
              }
            },
            false
          );

          canvas.addEventListener(
            "mouseup",
            function (evt) {
              dragStart = null;
              if (!dragged) zoom(evt.shiftKey ? -1 : 1);
            },
            false
          );

          canvas.addEventListener(
            "mouseout",
            function (evt) {
              dragStart = null;
            },
            false
          );

          var scaleFactor = 1.05;

          var zoom = function (clicks) {
            var pt = ctx.transformedPoint(lastX, lastY);
            ctx.translate(pt.x, pt.y);
            var factor = Math.pow(scaleFactor, clicks);
            ctx.scale(factor, factor);
            ctx.translate(-pt.x, -pt.y);
            redraw();
          };

          var handleScroll = function (evt) {
            var delta = evt.wheelDelta
              ? evt.wheelDelta / 40
              : evt.detail
              ? -evt.detail
              : 0;
            if (delta) zoom(delta);
            return evt.preventDefault() && false;
          };

          canvas.addEventListener("DOMMouseScroll", handleScroll, false);
          canvas.addEventListener("mousewheel", handleScroll, false);
          init = true;
        }
      };
    },
    async getArchivosAforo() {
      try {
        const { data } = await axios.get(
          `/api/admin/aforos/${this.aforoId}/archivos`
        );

        if (data?.data) {
          this.archivos = [...data?.data];

          this.carpeta = this.archivos.filter(
            (file) => file.fileable_type == "aforo_carpeta"
          );
          this.fotos = this.archivos.filter(
            (file) => file.fileable_type == "aforo_foto"
          );
        }
      } catch (e) {
        console.error(e);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al obtener los archivos de este aforo.",
        });
      }
    },
    async downloadArchivo() {
      window.open(
        process.env.VUE_APP_API_URL +
          `/api/admin/archivo/${this.idDescargar}/descargar/despacho`
      );
    },
    redimensionarVentana(e) {
      //console.log(e.windows)
    },
    atrasPagina() {
      this.paginaActual = this.paginaActual - 1;
      this.cargarPDF(this.paginaActual);
    },
    siguientePagina() {
      this.paginaActual = this.paginaActual + 1;
      this.cargarPDF(this.paginaActual);
    },
    async cargarPDF(pagina) {
      // Asynchronous download of PDF
      var loadingTask = getDocument(
        process.env.VUE_APP_API_URL + `/api/archivo/${this.idArchivo}/descargar`
      );

      loadingTask.promise.then(
        (pdf) => {          
          this.numeroPaginas = pdf.numPages;
          pdf.getPage(pagina).then((page) => {
            // Prepare canvas using PDF page dimensions
            var canvas_pdf = document.getElementById("visor-pdf-gen");
            var context = canvas_pdf.getContext("2d");
            var viewport = page.getViewport({ scale: 6 });
            canvas_pdf.width = viewport.width;
            canvas_pdf.height = viewport.height;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport,
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(() => {
              this.visorImagen.src = canvas_pdf.toDataURL("image/png");
            });
          });
        },
        function (reason) {
          // PDF loading error
          console.error(reason);
        }
      );
    },
    async cargarImagen() {
      this.visorImagen.src =
        process.env.VUE_APP_API_URL +
        `/api/archivo/${this.idArchivo}/descargar`;
    },
    trackTransforms(ctx) {
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var xform = svg.createSVGMatrix();
      ctx.getTransform = function () {
        return xform;
      };

      var savedTransforms = [];
      var save = ctx.save;
      ctx.save = function () {
        savedTransforms.push(xform.translate(0, 0));
        return save.call(ctx);
      };

      var restore = ctx.restore;
      ctx.restore = function () {
        xform = savedTransforms.pop();
        return restore.call(ctx);
      };

      var scale = ctx.scale;
      ctx.scale = function (sx, sy) {
        xform = xform.scaleNonUniform(sx, sy);
        return scale.call(ctx, sx, sy);
      };

      var rotate = ctx.rotate;
      ctx.rotate = function (radians) {
        xform = xform.rotate((radians * 180) / Math.PI);
        return rotate.call(ctx, radians);
      };

      var translate = ctx.translate;
      ctx.translate = function (dx, dy) {
        xform = xform.translate(dx, dy);
        return translate.call(ctx, dx, dy);
      };

      var transform = ctx.transform;
      ctx.transform = function (a, b, c, d, e, f) {
        var m2 = svg.createSVGMatrix();
        m2.a = a;
        m2.b = b;
        m2.c = c;
        m2.d = d;
        m2.e = e;
        m2.f = f;
        xform = xform.multiply(m2);
        return transform.call(ctx, a, b, c, d, e, f);
      };

      var setTransform = ctx.setTransform;
      ctx.setTransform = function (a, b, c, d, e, f) {
        xform.a = a;
        xform.b = b;
        xform.c = c;
        xform.d = d;
        xform.e = e;
        xform.f = f;
        return setTransform.call(ctx, a, b, c, d, e, f);
      };

      var pt = svg.createSVGPoint();
      ctx.transformedPoint = function (x, y) {
        pt.x = x;
        pt.y = y;
        return pt.matrixTransform(xform.inverse());
      };
    },

    visorLimpiar() {
      var canvas = document.getElementById("visor-canvas");
      canvas.width = 800;
      canvas.height = 400;
      var ctx = canvas.getContext("2d");
      var p1 = ctx.transformedPoint(0, 0);
      var p2 = ctx.transformedPoint(canvas.width, canvas.height);
      ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);
      this.visorImagen.src = "";
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-4 w-full">
    <div v-if="aforo?.tipo_inspeccion_id != 2" class="flex flex-col gap-4">
      <h1 class="!text-xl !font-bold">Fotos</h1>

      <div class="flex flex-row flex-wrap gap-4" v-if="fotos?.length > 0">
        <div class="" v-for="foto in fotos" v-bind:key="foto.id + '-foto'">
          <button
            class="w-12 h-12 hover:scale-110 transition-all"
            v-b-tooltip.hover
            :title="foto.ruta"
            @click="abrirDocumento(foto.id, foto.ruta)"
          >
            <inline-svg
              class="size-12"
              v-if="foto.ruta.split('.').at(-1) == 'pdf'"
              src="./../../../../assets/images/archivo-pdf.svg"
            />
            <inline-svg
              class="size-12"
              v-if="
                foto.ruta.split('.').at(-1) == 'png' ||
                foto.ruta.split('.').at(-1) == 'jpg' ||
                foto.ruta.split('.').at(-1) == 'jpeg'
              "
              src="./../../../../assets/images/archivo-png.svg"
            />
            <inline-svg
              class="size-12"
              v-if="
                foto.ruta.split('.').at(-1) == 'xlsx' ||
                foto.ruta.split('.').at(-1) == 'xls'
              "
              src="./../../../../assets/images/732220.svg"
            />
          </button>
        </div>
      </div>

      <div v-else>No hay fotos disponibles en este aforo</div>
    </div>

    <div class="flex flex-col gap-4">
      <h1 class="!text-xl !font-bold">Carpeta</h1>

      <div class="flex flex-row flex-wrap gap-4" v-if="carpeta?.length > 0">
        <div
          class=""
          v-for="archivo in carpeta"
          v-bind:key="archivo.id + '-file'"
        >
          <button
            class="w-12 h-12 hover:scale-110 transition-all"
            v-b-tooltip.hover
            :title="archivo.ruta"
            @click="abrirDocumento(archivo.id, archivo.ruta)"
          >
            <inline-svg
              class="size-12"
              v-if="archivo.ruta.split('.').at(-1) == 'pdf'"
              src="./../../../../assets/images/archivo-pdf.svg"
            />
            <inline-svg
              class="size-12"
              v-if="
                archivo.ruta.split('.').at(-1) == 'png' ||
                archivo.ruta.split('.').at(-1) == 'jpg' ||
                archivo.ruta.split('.').at(-1) == 'jpeg'
              "
              src="./../../../../assets/images/archivo-png.svg"
            />
            <inline-svg
              class="size-12"
              v-if="
                archivo.ruta.split('.').at(-1) == 'xlsx' ||
                archivo.ruta.split('.').at(-1) == 'xls'
              "
              src="./../../../../assets/images/732220.svg"
            />
          </button>
        </div>
      </div>

      <div v-else>No hay archivos disponibles en este aforo</div>
    </div>

    <div id="visualizacion-documentos-adjuntos-1" class="flex flex-col gap-4">
      <div v-if="tipoDeArchivo === ''" style="text-align: center"></div>
      <div v-else class="flex flex-col gap-4">
        <div class="flex flex-row justify-between items-center">
          <h3 class="!text-xl !font-bold text-left">Visualizador</h3>

          <button class="btn-principal" @click="() => downloadArchivo()">
            <fas :icon="['fas', 'download']"></fas>
            Descargar
          </button>
        </div>
        <div
          class="flex flex-col gap-4 w-full"
          v-if="tipoDeArchivo === 'png' || tipoDeArchivo === 'pdf'"
        >
          <canvas id="visor-pdf-gen"></canvas>
          <div class="visor-cuerpo">
            <canvas
              id="visor-canvas"
              :width="visorWidth"
              :height="visorHeight"
            ></canvas>
          </div>
          <div
            class="flex flex-row w-36 justify-center mx-auto gap-4 text-center"
            v-if="tipoDeArchivo == 'pdf'"
          >
            <button
              class="btn-principal !w-4"
              @click="atrasPagina()"
              :disabled="paginaActual <= 1"
            >
              <fas :icon="['fas', 'chevron-left']" />
            </button>
            <button class="btn-nomx text-white bg-secondary/80">
              {{ paginaActual }}
            </button>
            <button
              @click="siguientePagina()"
              class="btn-principal !w-4"
              :disabled="paginaActual == numeroPaginas"
            >
              <fas :icon="['fas', 'chevron-right']" />
            </button>
          </div>
        </div>
        <div v-else>
          <h3>No se puede visualizar el archivo.</h3>
        </div>
      </div>
    </div>
  </div>
</template>
